import { Section } from 'components/Section';
import { useSelector } from 'react-redux';
import { isMobile as isMobileSelector } from 'components/Shared/responsive';
import { Appearances } from 'models/SectionBlock';
import { KnowledgebaseMenuItem } from 'models/KnowledgebaseMenuItem';
import { HouseLinks } from 'components/Macro/components/houseLinks';

interface HeatingProps {
  items: KnowledgebaseMenuItem[];
  title: string;
}

export const HeatingArea = ({ items, title }: HeatingProps) => {
  const isMobile = useSelector(isMobileSelector);

  return (
    <Section title={title} isDesktop={!isMobile} appearance={Appearances.Tertiary}>
      <HouseLinks items={items} appearance="secondary" />
    </Section>
  );
};
